import { usePocQuery } from 'core/custom-hooks/use-poc-query.hook';
import { userLocationAssignmentKeys } from 'core/query-client/keys/user-location-assignment.keys';
import { getUserAssignedLocationIds } from '../user-locations.service';

/**
 * Reads the user's current assignment for the dialog to seed from. Called bare rather than through
 * executeRequest: the dialog renders its own inline failure, so a generic toast would double up.
 */
export const useUserLocationsQuery = (userId: string) => {
    const { data, isLoading, isFetching, isError, refetch } = usePocQuery<string[]>({
        queryKey: userLocationAssignmentKeys.detail(userId),
        queryFn: () => getUserAssignedLocationIds(userId),
        enabled: Boolean(userId),
        // The dialog must open on the server's current set, not on whatever the list cached earlier.
        staleTime: 0,
    });

    return {
        assignedLocationIds: data ?? [],
        isLoading: isLoading || isFetching,
        isError,
        refetch,
    };
};
